import { render, staticRenderFns } from "./AddUpdataProduct.vue?vue&type=template&id=5acd360c&scoped=true&"
import script from "./AddUpdataProduct.vue?vue&type=script&lang=js&"
export * from "./AddUpdataProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acd360c",
  null
  
)

export default component.exports